<template>
  <v-layout align-start>
    <v-flex>
      <v-card>
        <v-app-bar color="white" elevate-on-scroll flat>
          <v-row v-if="mostrarBusquedas">
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                outlined
                dense
                class="text-xs-center"
                v-model="searchAll"
                append-icon="search"
                label="Búsqueda"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="3" sm="3" md="3">
              <v-autocomplete
                outlined
                dense
                ref="anio"
                v-model="anio"
                :items="anioList"
                :rules="[$rules.requerido]"
                :error-messages="errorMessages"
                item-text="descripcion"
                item-value="id"
                label="Gestión"
                required
              ></v-autocomplete>
            </v-col>
            <v-col cols="3" sm="3" md="3">
              <v-autocomplete
                dense
                outlined
                ref="mes"
                v-model="mes"
                :items="mesList"
                @change="limpiar"
                :rules="[$rules.requerido]"
                :error-messages="errorMessages"
                item-text="descripcion"
                item-value="id"
                label="Mes"
                required
              >
                <template v-slot:no-data>
                  No hay información disponible
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="4" sm="4" md="4">
              <v-autocomplete
                dense
                outlined
                v-model="searchClasificacion"
                :items="clasificacionList"
                @change="limpiar"
                append-icon="search"
                label="Clasificación"
                item-text="codigo"
                item-value="descripcion"
                clearable
              ></v-autocomplete>
            </v-col>
           
          </v-row>

          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="listar"
                :loading="loadButton"
                :disabled="!mes || !searchClasificacion"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> fa-solid fa-display </v-icon>
              </v-btn>
            </template>
            <span>Mostrar reporte en pantalla</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="exportarExcel"
                :loading="loadingExcel"
                :disabled="!mes || !searchClasificacion"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> fa-solid fa-file-excel </v-icon>
              </v-btn>
            </template>
            <span>Exportar reporte a Excel</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="mostrarBusqueda"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark>
                  {{ mostrarBusquedas ? "search_off" : "search" }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{
              mostrarBusquedas
                ? "Ocultar filtros de búsqueda"
                : "Mostrar filtros de búsqueda"
            }}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="mostrarCarga"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> file_upload </v-icon>
              </v-btn>
            </template>
            <span>Carga masiva de datos</span>
          </v-tooltip>
          
        </v-app-bar>

        <v-sheet class="overflow-y-auto" :max-height="windowHeigth">
          <v-data-table
            dense
            fixed-header
            :height="windowHeigth - (isMobile ? 128 : 200)"
            :headers="headersCuc"
            :items="dtGastos"
            :hide-default-header="isMobile"
            mobile-breakpoint="0"
            sort-by="codigo"
            :single-expand="singleExpand"
            :expanded.sync="expanded"
            item-key="cuenta"
            show-expand
            class="elevation-1"
            :loading="dtGastosLoad"
            loading-text="Cargando... Espere por favor"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': [-1, 100, 150, 200],
            }"
          >
            <template slot="body.append">
              <td colspan="2" align="right" class="font-weight-bold">
                Totales
              </td>

              <td align="right" class="font-weight-bold">
                {{ $formatoNumero(totalsGastos.ant_real3) }}
              </td>

              <td align="right" class="font-weight-bold">
                {{ $formatoNumero(totalsGastos.ant_real2) }}
              </td>

              <td align="right" class="font-weight-bold">
                {{ $formatoNumero(totalsGastos.ant_real1) }}
              </td>

              <td align="right" class="font-weight-bold">
                {{ $formatoNumero(totalsGastos.ant_real) }}
              </td>

              <td align="right" class="font-weight-bold">
                {{ $formatoNumero(totalsGastos.act_real) }}
              </td>

              <td align="right" class="font-weight-bold">
                {{ $formatoNumero(totalsGastos.estimado) }}
              </td>
              <td align="right" class="font-weight-bold">
                {{
                  $formatoNumero(totalsGastos.act_real - totalsGastos.ant_real)
                }}
              </td>
              <td align="right" class="font-weight-bold">
                {{
                  $formatoNumeroPorcentaje(
                    (totalsGastos.act_real /
                      (totalsGastos.ant_real === 0
                        ? 1
                        : totalsGastos.ant_real)) *
                      100 -
                      100
                  )
                }}
              </td>
              <td align="right" class="font-weight-bold">
                {{
                  $formatoNumero(totalsGastos.act_real - totalsGastos.estimado)
                }}
              </td>
              <td align="right" class="font-weight-bold">
                {{
                  $formatoNumeroPorcentaje(
                    (totalsGastos.act_real /
                      (totalsGastos.estimado === 0
                        ? 1
                        : totalsGastos.estimado)) *
                      100
                  )
                }}
              </td>
            </template>
            <template slot="body.prepend">
              <td colspan="2" align="right" class="font-weight-bold">
                Totales
              </td>

              <td align="right" class="font-weight-bold">
                {{ $formatoNumero(totalsGastos.ant_real3) }}
              </td>

              <td align="right" class="font-weight-bold">
                {{ $formatoNumero(totalsGastos.ant_real2) }}
              </td>

              <td align="right" class="font-weight-bold">
                {{ $formatoNumero(totalsGastos.ant_real1) }}
              </td>

              <td align="right" class="font-weight-bold">
                {{ $formatoNumero(totalsGastos.ant_real) }}
              </td>

              <td align="right" class="font-weight-bold">
                {{ $formatoNumero(totalsGastos.act_real) }}
              </td>

              <td align="right" class="font-weight-bold">
                {{ $formatoNumero(totalsGastos.estimado) }}
              </td>
              <td align="right" class="font-weight-bold">
                {{
                  $formatoNumero(totalsGastos.act_real - totalsGastos.ant_real)
                }}
              </td>
              <td align="right" class="font-weight-bold">
                {{
                  $formatoNumeroPorcentaje(
                    (totalsGastos.act_real /
                      (totalsGastos.ant_real === 0
                        ? 1
                        : totalsGastos.ant_real)) *
                      100 -
                      100
                  )
                }}
              </td>
              <td align="right" class="font-weight-bold">
                {{
                  $formatoNumero(totalsGastos.act_real - totalsGastos.estimado)
                }}
              </td>
              <td align="right" class="font-weight-bold">
                {{
                  $formatoNumeroPorcentaje(
                    (totalsGastos.act_real /
                      (totalsGastos.estimado === 0
                        ? 1
                        : totalsGastos.estimado)) *
                      100
                  )
                }}
              </td>
            </template>

            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <v-data-table
                  dense
                  fixed-header
                  :headers="headersCenco"
                  :items="item.reporte_gastos"
                  :hide-default-header="false"
                  mobile-breakpoint="0"
                  sort-by="cenco"
                  hide-default-footer
                >
                  <template v-slot:[`header.act_real`]>{{
                    "Real " + anio
                  }}</template>
                  <template v-slot:[`header.ant_real3`]>{{
                    "Real " + (anio - 4)
                  }}</template>
                  <template v-slot:[`header.ant_real2`]>{{
                    "Real " + (anio - 3)
                  }}</template>
                  <template v-slot:[`header.ant_real1`]>{{
                    "Real " + (anio - 2)
                  }}</template>
                  <template v-slot:[`header.ant_real`]>{{
                    "Real " + (anio - 1)
                  }}</template>
                  <template v-slot:[`header.estimado`]>{{
                    "Estimado " + anio
                  }}</template>
                  <template v-slot:[`header.var1`]>{{
                    "Varianza " + (anio - 1) + ".vs." + anio
                  }}</template>
                  <template v-slot:[`header.var2`]>{{ "% Varianza" }}</template>
                  <template v-slot:[`header.cump1`]>{{
                    "Cumplimiento"
                  }}</template>

                  <template v-slot:[`header.cump2`]>{{
                    "% Cumplimiento"
                  }}</template>

                  <template v-slot:[`item.act_real`]="{ item }">
                    {{ $formatoNumero(item.act_real) }}
                  </template>
                  <template v-slot:[`item.ant_real`]="{ item }">
                    {{ $formatoNumero(item.ant_real) }}
                  </template>
                  <template v-slot:[`item.ant_real3`]="{ item }">
                    {{ $formatoNumero(item.ant_real3) }}
                  </template>
                  <template v-slot:[`item.ant_real2`]="{ item }">
                    {{ $formatoNumero(item.ant_real2) }}
                  </template>
                  <template v-slot:[`item.ant_real1`]="{ item }">
                    {{ $formatoNumero(item.ant_real1) }}
                  </template>
                  <template v-slot:[`item.estimado`]="{ item }">
                    {{ $formatoNumero(item.estimado) }}
                  </template>
                  <template v-slot:[`item.var1`]="{ item }">
                    {{ $formatoNumero(item.var1) }}
                  </template>
                  <template v-slot:[`item.var2`]="{ item }">
                    {{ $formatoNumeroPorcentaje(item.var2) }}
                  </template>
                  <template v-slot:[`item.cump1`]="{ item }">
                    {{ $formatoNumero(item.cump1) }}
                  </template>
                  <template v-slot:[`item.cump2`]="{ item }">
                    {{ $formatoNumeroPorcentaje(item.cump2) }}
                  </template>
                </v-data-table>
              </td>
            </template>

            <template v-slot:[`header.act_real`]>{{ "Real " + anio }}</template>
            <template v-slot:[`header.ant_real`]>{{
              "Real " + (anio - 1)
            }}</template>
            <template v-slot:[`header.ant_real3`]>{{
              "Real " + (anio - 4)
            }}</template>
            <template v-slot:[`header.ant_real2`]>{{
              "Real " + (anio - 3)
            }}</template>
            <template v-slot:[`header.ant_real1`]>{{
              "Real " + (anio - 2)
            }}</template>
            <template v-slot:[`header.estimado`]>{{
              "Estimado " + anio
            }}</template>
            <template v-slot:[`header.var1`]>{{
              "Varianza " + (anio - 1) + ".vs." + anio
            }}</template>
            <template v-slot:[`header.var2`]>{{ "% Varianza" }}</template>
            <template v-slot:[`header.cump1`]>{{ "Cumplimiento" }}</template>

            <template v-slot:[`header.cump2`]>{{ "% Cumplimiento" }}</template>

            <template v-slot:[`item.cuc_descripcion`]="{ item }">
              <div class="font-weight-bold">{{ item.cuc_descripcion }}</div>
            </template>
            <template v-slot:[`item.act_real`]="{ item }">
              <div class="font-weight-bold">
                {{ $formatoNumero(item.act_real) }}
              </div>
            </template>
            <template v-slot:[`item.ant_real`]="{ item }">
              <div class="font-weight-bold">
                {{ $formatoNumero(item.ant_real) }}
              </div>
            </template>
            <template v-slot:[`item.ant_real1`]="{ item }">
              <div class="font-weight-bold">
                {{ $formatoNumero(item.ant_real1) }}
              </div>
            </template>
            <template v-slot:[`item.ant_real2`]="{ item }">
              <div class="font-weight-bold">
                {{ $formatoNumero(item.ant_real2) }}
              </div>
            </template>
            <template v-slot:[`item.ant_real3`]="{ item }">
              <div class="font-weight-bold">
                {{ $formatoNumero(item.ant_real3) }}
              </div>
            </template>
            <template v-slot:[`item.estimado`]="{ item }">
              <div class="font-weight-bold">
                {{ $formatoNumero(item.estimado) }}
              </div>
            </template>
            <template v-slot:[`item.var1`]="{ item }">
              <div class="font-weight-bold">
                {{ $formatoNumero(item.var1) }}
              </div>
            </template>
            <template v-slot:[`item.var2`]="{ item }">
              <div class="font-weight-bold">
                {{ $formatoNumeroPorcentaje(item.var2) }}
              </div>
            </template>
            <template v-slot:[`item.cump1`]="{ item }">
              <div class="font-weight-bold">
                {{ $formatoNumero(item.cump1) }}
              </div>
            </template>
            <template v-slot:[`item.cump2`]="{ item }">
              <div class="font-weight-bold">
                {{ $formatoNumeroPorcentaje(item.cump2) }}
              </div>
            </template>

            <template v-slot:[`item.opciones`]="{ item }">
              <v-btn x-small text dark color="primary" @click="editar(item)">
                <v-icon x-small>edit</v-icon>
              </v-btn>
            </template>

            <template v-slot:[`item.estado`]="{ item }">
              <div v-if="item.estado == 'I'">
                <v-btn
                  color="error"
                  x-small
                  text
                  dark
                  @click="abrirDialogActivacion(item)"
                >
                  <v-icon x-small>block</v-icon>
                </v-btn>
              </div>
              <div v-else>
                <v-btn
                  color="success"
                  x-small
                  text
                  dark
                  @click="abrirDialogActivacion(item)"
                >
                  <v-icon x-small>check</v-icon>
                </v-btn>
              </div>
            </template>

            <template v-slot:[`item.subarea`]="{ item }">
              <div v-if="item.subarea == 'NO DEFINIDO'" class="error--text">
                {{ item.subarea }}
              </div>
              <div v-else>
                {{ item.subarea }}
              </div>
            </template>

            <template v-slot:no-data>
              <div>
                {{
                  $esNulo(mes) || $esNulo(searchClasificacion)
                    ? "Debe seleccionar un mes y una clasificación"
                    : "No se encontraron registros"
                }}
              </div>
            </template>
          </v-data-table>
        </v-sheet>
      </v-card>
      <v-dialog v-model="dialogCargaExcel" max-width="40%">
        <v-card>
          <v-app-bar color="white" elevate-on-scroll flat>
            <v-card-title>
              <span class="headline">Carga Masiva de Datos</span>
            </v-card-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="cerrarCarga"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> close </v-icon>
                </v-btn>
              </template>
              <span>Cancelar</span>
            </v-tooltip>
          </v-app-bar>

          <v-card-text>
            <v-file-input
              dense
              id="file"
              ref="file"
              v-model="file"
              @change="archivoCambiado"
              show-size
              chips
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              prepend-icon="attach_file"
              placeholder="Seleccione un archivo Excel"
            >
              <template v-slot:selection="{ text }">
                <v-chip color="primary">
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
            <v-spacer></v-spacer>
            <span
              >Debe cargar un archivo Excel que contengan las siguientes
              cabeceras en la primera fila: | CODIGO_CUENTA | CODIGO_CENCO | AÑO
              | MES | MONTO(Bs.) | tipo ("EST"=>Estimado o "AJU"=>Ajuste)
            </span>
            <div v-show="mostrarErrores">
              <v-textarea
                outlined
                dense
                ref="error"
                v-model="error"
                :rules="[]"
                :readonly="true"
                :error-messages="errorMessages"
                label="Lista de Errores"
                placeholder="Lista de Errores"
                required
              ></v-textarea>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="guardarExcel"
                  color="success"
                  :loading="loadButton"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> done </v-icon>
                </v-btn>
              </template>
              <span>Cargar archivo</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogAlpha" persistent max-width="390">
        <v-card>
          <v-card-title>¿Está seguro?</v-card-title>
          <v-card-text
            >Esta acción {{ estado == "A" ? "desactivará" : "activará" }} el
            elemento seleccionado.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogAlpha = false">Cancelar</v-btn>
            <div v-if="estado == 'A'">
              <v-btn color="primary" text @click="desactivar()"
                >Continuar</v-btn
              >
            </div>
            <div v-else>
              <v-btn color="primary" text @click="activar()">Continuar</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogBeta"
        :fullscreen="isMobile"
        max-width="500px"
        persistent
      >
        <v-card ref="form">
          <v-app-bar color="white" elevate-on-scroll flat>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="guardar"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> save </v-icon>
                </v-btn>
              </template>
              <span>Guardar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="cerrar"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> close </v-icon>
                </v-btn>
              </template>
              <span>Cancelar</span>
            </v-tooltip>
          </v-app-bar>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    outlined
                    dense
                    ref="codigo"
                    v-model="codigo"
                    :readonly="!editarCodigo"
                    :rules="[$rules.requerido, $rules.max10]"
                    :error-messages="errorMessages"
                    @keydown.enter.prevent="guardar"
                    @keydown.escape.prevent="cerrar"
                    label="Código"
                    placeholder="Código"
                    required
                  ></v-text-field>

                  <v-text-field
                    outlined
                    dense
                    reverse
                    ref="siguiente_recibo"
                    v-model="siguiente_recibo"
                    @keydown.enter.prevent="guardar"
                    @keydown.escape.prevent="cerrar"
                    :rules="[$rules.requerido, $rules.numero]"
                    :error-messages="errorMessages"
                    label="Siguiente Correlativo"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      //Declaración de variables globales
      usuario: this.$store.state.usuario.user,
      //Declaración de arrays
      dtGastos: [],
      dtGastosLoad: false,
      areaList: [],
      subareaList: [],
      areaPresupList: [],
      anioList: [],
      expanded: [],
      clasificacionList: [],

      singleExpand: false,
      mesList: [
        { id: "1", descripcion: "Enero" },
        { id: "2", descripcion: "Febrero" },
        { id: "3", descripcion: "Marzo" },
        { id: "4", descripcion: "Abril" },
        { id: "5", descripcion: "Mayo" },
        { id: "6", descripcion: "Junio" },
        { id: "7", descripcion: "Julio" },
        { id: "8", descripcion: "Agosto" },
        { id: "9", descripcion: "Septiembre" },
        { id: "10", descripcion: "Octubre" },
        { id: "11", descripcion: "Noviembre" },
        { id: "12", descripcion: "Diciembre" },
      ],

      //Declaración de variables de Dialog
      dialogBeta: false,
      dialogCargaExcel: false,
      dialogAlpha: false,
      dialogGamma: false,

      //Declaración de variables de formulario
      id: "",
      codigo: "",
      siguiente_recibo: "",
      searchClasificacion: "",
      anio: "",
      mes: "",

      estado: "",

      file: null,

      load: false,
      loadingExcel: false,
      loadButton: false,
      icono: "",
      color: "",
      //Declaración de variables de tabla

      selected: [2],

      headersCuc: [
        {
          text: "Cuenta",
          value: "cuc_descripcion",
          align: "left",
          width: "30%",
          class: "primary font-weight-black white--text text-subtitle-2",
        },

        {
          text: "Real ",
          value: "ant_real3",
          align: "right",
          width: "10%",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        {
          text: "Real ",
          value: "ant_real2",
          align: "right",
          width: "10%",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        {
          text: "Real ",
          value: "ant_real1",
          align: "right",
          width: "10%",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        {
          text: "Real ",
          value: "ant_real",
          align: "right",
          width: "10%",
          class: "primary font-weight-black white--text text-subtitle-2",
        },

        {
          text: "Real ",
          value: "act_real",
          align: "right",
          width: "10%",
          class: "primary font-weight-black white--text text-subtitle-2",
        },

        {
          text: "Estimado ",
          value: "estimado",
          align: "right",
          width: "10%",
          class: "primary font-weight-black white--text text-subtitle-2",
        },

        {
          text: "Varianza ",
          value: "var1",
          align: "right",
          width: "10%",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        {
          text: "% Varianza",
          value: "var2",
          align: "right",
          width: "10%",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        {
          text: "Cumplimiento",
          value: "cump1",
          align: "right",
          width: "10%",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        {
          text: "% Cumplimiento",
          value: "cump2",
          align: "right",
          width: "10%",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        {
          text: "clasificacion",
          value: "clasificacion",
          align: " d-none",
          width: "10%",
          visible: "primary font-weight-black white--text text-subtitle-2",
        },
      ],
      headersCenco: [
        {
          text: "",
          value: "cenco",
          align: "left",
          width: "5%",
          sortable: false,
        },
        {
          text: "Centro de Costo",
          value: "cco_descripcion",
          align: "left",
          width: "25%",
          sortable: false,
        },
        {
          text: "Real ",
          value: "ant_real3",
          align: "right",
          width: "10%",
          sortable: false,
        },
        {
          text: "Real ",
          value: "ant_real2",
          align: "right",
          width: "10%",
          sortable: false,
        },
        {
          text: "Real ",
          value: "ant_real1",
          align: "right",
          width: "10%",
          sortable: false,
        },
        {
          text: "Real ",
          value: "ant_real",
          align: "right",
          width: "10%",
          sortable: false,
        },

        {
          text: "Real " + this.anio,
          value: "act_real",
          align: "right",
          width: "10%",
          sortable: false,
        },

        {
          text: "Estimado " + this.anio,
          value: "estimado",
          align: "right",
          width: "10%",
          sortable: false,
        },

        {
          text: "Varianza " + (this.anio - 1) + "vs" + this.anio,
          value: "var1",
          align: "right",
          width: "10%",
          sortable: false,
        },
        {
          text: "% Varianza",
          value: "var2",
          align: "right",
          width: "10%",
          sortable: false,
        },
        {
          text: "Cumplimiento",
          value: "cump1",
          align: "right",
          width: "10%",
          sortable: false,
        },
        {
          text: "% Cumplimiento",
          value: "cump2",
          align: "right",
          width: "10%",
          sortable: false,
        },
      ],

      searchAll: "",
      esEditado: false,
      editarCodigo: false,

      editedIndexCco: false,
      inactivos: false,
      mostrarErrores: false,
      mostrarBusquedas: false,
      //variables de errrores
      valida: 0,
      errorMessages: "",

      error: "",
      //variables de tamaño de pantalla
      isMobile: false,

      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight,

      windowWidth: window.innerWidth + this.auxWidth,
      windowHeigth: window.innerHeight,
    };
  },

  computed: {
    formTitle() {
      return !this.esEditado ? "Nuevo Registro" : "Actualizar Registro";
    },

    form() {
      return {
        codigo: this.codigo,
        siguiente_recibo: this.siguiente_recibo,
      };
    },

    totalsGastos() {
      const totalsGastos = this.dtGastos.reduce(
        (gastosDet, d) => {
          gastosDet.ant_real += d.ant_real;
          gastosDet.ant_real1 += d.ant_real1;
          gastosDet.ant_real2 += d.ant_real2;
          gastosDet.ant_real3 += d.ant_real3;
          gastosDet.act_real += d.act_real;
          gastosDet.estimado += d.estimado;
          gastosDet.var1 += d.var1;
          gastosDet.var2 += d.var2;
          gastosDet.cump1 += d.cump1;
          gastosDet.cump2 += d.cump2;
          gastosDet.monto += d.monto;

          return gastosDet;
        },
        {
          ant_real: 0,
          ant_real1: 0,
          ant_real2: 0,
          ant_real3: 0,
          act_real: 0,
          estimado: 0,
          var1: 0,
          var2: 0,
          cump1: 0,
          cump2: 0,
          monto: 0,
        }
      );
      //totals.proy = totals.proy.toFixed(1) //para agregar decimales
      return totalsGastos;
    },
  },

  watch: {
    dialogBeta(val) {
      val || this.cerrar();
    },

    name() {
      this.errorMessages = "";
    },
  },
  mounted() {
    window.addEventListener("resize", this.getDimensions);
  },
  unmounted() {
    window.removeEventListener("resize", this.getDimensions);
  },

  created() {
    //this.$gtag.pageview('/areaDelPresupuestoPrueba')
    this.$store.dispatch("actualizarTitulo", "Análisis de Gastos");
    this.generarAnios();
    this.selectClasificacion();
  },
  beforeDestroy() {
    this.$store.dispatch("actualizarTitulo", "");
  },

  methods: {
    archivoCambiado(e) {
      this.selectedFile = e;
    },

    getDimensions() {
      this.width = document.documentElement.clientWidth;
      this.height = document.documentElement.clientHeight;
      this.isMobile = this.width < 768;
    },
    listar() {
      let me = this;
      me.dtGastosLoad = true;
      axios
        .get(
          "api/reportes/listarReporteGastos/" +
            me.anio +
            "/" +
            me.mes +
            "/" +
            me.searchClasificacion
        )
        .then(function (response) {
          me.dtGastos = response.data;
          console.log(me.dtGastos);

          me.windowWidth = window.innerWidth + me.auxWidth;
          me.windowHeigth = window.innerHeight;
          me.dtGastosLoad = false;
        })
        .catch(function (error) {
          me.dtGastosLoad = false;
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },

    mostrarInactivos() {
      this.inactivos = !this.inactivos;
      this.listar();
    },

    abrirDialogActivacion(item) {
      this.id = item.id;
      this.dialogAlpha = true;
      this.estado = item.estado;
    },

    mostrarBusqueda() {
      this.mostrarBusquedas = !this.mostrarBusquedas;
      this.windowWidth = window.innerWidth;
      this.windowHeigth = window.innerHeight;
    },

    archivoCambiado(e) {
      this.selectedFile = e;
    },

    cerrarCarga() {
      this.dialogCargaExcel = false;
      this.loadButton = false;
      this.limpiarCargaExcel();
    },

    mostrarCarga() {
      this.dialogCargaExcel = true;
    },

    editar(item) {
      this.id = item.id;
      this.codigo = item.codigo;
      this.siguiente_recibo = item.siguiente_recibo;

      this.esEditado = true;
      this.editarCodigo = false;
      this.dialogBeta = true;

      //debe agregarse $nextTick para los elementos no renderizados hastas su llamada
    },

    cerrar() {
      this.dialogBeta = false;
      this.limpiar();
    },

    limpiar() {
      this.id = "";
      this.codigo = "";
      this.siguiente_recibo = "";
      this.dtGastos = [];

      this.dialogBeta = false;
      this.esEditado = false;
    },
    limpiarCargaExcel() {
      this.file = null;
      this.selectedFile = null;
      this.error = "";
      this.mostrarErrores = false;
    },

    guardar() {
      if (this.validar() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }
      if (this.esEditado) {
        //codigo para editar
        let me = this;
        axios
          .put("api/talonarios/actualizar", {
            id: me.id,
            codigo: me.codigo,
            siguiente_recibo: me.siguiente_recibo,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.cerrar();
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: " Registro modificado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      } else {
        //codigo para guardar
        let me = this;
        axios
          .post("api/talonarios/crear", {
            codigo: me.codigo,
            siguiente_recibo: me.siguiente_recibo,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.esEditado = true;
            me.id = response.data;
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: " Registro creado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },

    exportarExcel() {
      let me = this;
      me.loadingExcel = true;
     
      axios({
        url:
        "api/reportes/ExportarExcelReporteGastos/" +
            me.anio +
            "/" +
            me.mes +
            "/" +
            me.searchClasificacion,
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "Reporte de Gastos - " + Date.now().toString() + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
        me.loadingExcel = false;
        me.$store.dispatch("setSnackbar", {
          text: "Excel generado exitosamente",
          color: "success",
        });
      });
    },

    selectClasificacion() {
      let me = this;
      axios
        .get("api/cuenta_contables/SelectClasificacion")
        .then(function (response) {
          me.clasificacionList = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    guardarExcel() {
      let me = this;
      const formData = new FormData();
      me.loadButton = true;

      if (this.selectedFile != null) {
        formData.append(this.selectedFile.name, this.selectedFile);
        axios
          .put(
            "api/reportes/cargarExcelPresupuestoEstimado/" + me.usuario,
            formData
          )
          .then(function (response) {
            me.$store.dispatch("setSnackbar", {
              text: response.data,
              color: "success",
            });
            me.cerrarCarga();
            me.listar();
          })
          .catch(function (err) {
            me.mostrarErrores = true;
            me.$store.dispatch("setSnackbar", {
              text: "No se pudo cargar el archivo  seleccionado, verifique los errores e intente nuevamente.",
              color: "error",
            });
            me.error = err.response.data;
            me.loadButton = false;
          });
      } else {
        formData.append(null, null);
        me.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un archivo para cargar.",
          color: "warning",
        });
      }
    },

    validar() {
      this.valida = 0;

      Object.keys(this.form).forEach((f) => {
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.valida += 0;
        } else {
          this.valida += 1;
        }
      });
      return this.valida;
    },

    activar() {
      let me = this;
      axios
        .put("api/talonarios/activar/" + me.id + "/" + me.usuario, {})
        .then(function (response) {
          me.listar();
          me.dialogAlpha = false;
          me.$store.dispatch("setSnackbar", {
            text: " Registro activado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    desactivar() {
      let me = this;
      axios
        .put("api/talonarios/desactivar/" + me.id + "/" + me.usuario, {})
        .then(function (response) {
          me.listar();
          me.dialogAlpha = false;
          me.$store.dispatch("setSnackbar", {
            text: "Registro desactivado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    generarAnios() {
      let me = this;
      var anioActual = new Date().getUTCFullYear();
      anioActual -= 5;

      for (var i = 0; i < 15; i++) {
        const dato = {
          id: anioActual.toString(),
          descripcion: anioActual.toString(),
        };
        this.anioList.push(dato);
        anioActual += 1;
      }

      this.anio = (anioActual - 10).toString();
    },

    download(link, title) {
      var element = document.createElement("a");
      element.setAttribute("href", link);
      element.setAttribute("download", title);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },

    //format datetime to dd/mm/yyyy hh:mm:ss
  },
};
</script>
